export const PARAM_CLI_SUCCES = 'PARAM_CLI_SUCCES'
export const PARAM_CLI_ECHEC = 'PARAM_CLI_ECHEC'

export const PARAM_UPDATE_SUCCES = 'PARAM_UPDATE_SUCCES'
export const PARAM_UPDATE_ECHEC = 'PARAM_UPDATE_ECHEC'
